// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueCookies from 'vue-cookies'
import {axiosGet,axiosPost,axiosPostUploadImage} from './public/axios.js'; //封装好的 请求方法
import {CAFGetList,CAFSubmit,CAFDelete} from './public/CommonAjaxFun.js'; //封装 公用增删改查 请求
import './public/ElementUI.js'; //封装ElementUI
import Global from '@/config/URL.js' //公用变量  路径
 import moment from 'moment';
//  import Print from 'vue-print-nb'
// 　　Vue.use(Print); //注册
// import FileSaver from 'file-saver'
// import XLSX from 'xlsx'
Vue.use(VueCookies);
Axios.defaults.withCredentials=true
Vue.config.productionTip = false
Vue.prototype.$axios=Axios;
Vue.prototype.axiosGet = axiosGet;   //放入全局 get 请求
Vue.prototype.axiosPost = axiosPost;   //放入全局  post 请求
Vue.prototype.axiosPostUploadImage = axiosPostUploadImage;   //放入全局  封装 图片上传
Vue.prototype.httpUrl = Global.httpUrl;   //公用方法 路径
Vue.prototype.appHttpUrl = Global.appHttpUrl;   //公用方法 路径
Vue.prototype.CAFGetList = CAFGetList;   //来自  CommonAjaxFun中的公用获取初始列表的方法
Vue.prototype.CAFSubmit = CAFSubmit;   //来自  CommonAjaxFun中的 添加方法
Vue.prototype.CAFDelete = CAFDelete;   //来自  CommonAjaxFun中的 删除方法
Vue.prototype.$moment = moment;//赋值使用
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js